import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { routes } from './app.routes'; 
import { provideHttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationService } from './shared/services/translation.service';
import { HttpLoaderFactory } from './shared/factories/translation-loader.factory';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';
import { IonicRouteStrategy } from '@ionic/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21 made zoneless change detection the default and dropped the
    // implicit Zone.js dependency. This app still keeps its state in plain
    // component fields that are mutated from async callbacks (HTTP, PouchDB,
    // overlays), which no longer schedules a re-render on its own.
    // Opting back into Zone.js restores the pre-upgrade rendering behaviour
    // app-wide. Remove this once pages are migrated to signals / AsyncPipe.
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    Globalization,
    importProvidersFrom(
      IonicModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [TranslationService]
        }
      }),
      IonicStorageModule.forRoot({
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
      })
    ),
  ],
};
